import _ from 'lodash';
import PolicySearchUtil from 'gw-portals-util-angular/PolicySearchUtil';
import templateStr from 'text!./templates/policy-search-criteria.html';

export default ['LocaleService', 'ModalService', (LocaleService, ModalService) => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            'criteria': '=',
            'search': '=',
            'resetSearch': '=',
            'allowedPolicyTypes': '=',
            'policySearchPromise': '&'
        },
        controller: ['$scope', 'ViewModelService', ($scope, ViewModelService) => {
            $scope.criteriaVM = ViewModelService.create($scope.criteria, 'cc', 'edge.capabilities.claim.fnol.policy.dto.PolicySearchCriteriaDTO');
            // PSA $scope.criteriaVM.country.value = $scope.criteriaVM.country.value || LocaleService.getCountry().code;

            $scope.policyTypes = _.filter($scope.criteriaVM.policyType.aspects.availableValues, (type) => {
                return _.includes($scope.allowedPolicyTypes, type.code);
            });

            // PSA $scope.searchIsBlank = PolicySearchUtil.searchIsBlank; uses search_PSA instead and shows popup

            /**
             * Reset the search criteria form
             */
            $scope.resetSearchCriteria = () => {
                $scope.criteria.firstName = null;
                $scope.criteria.lastName = null;
                $scope.criteria.policyType = null;
                $scope.criteria.city = null;
                $scope.criteria.state = null;
                $scope.criteria.zip = null;

                $scope.criteria.country = null; // PSA
                $scope.criteria.companyName = null; // PSA
                $scope.criteria.vin_PSA = null; // PSA
                $scope.criteria.licensePlate_PSA = null; // PSA

                if ($scope.resetSearch) {
                    $scope.resetSearch();
                }
            };

            $scope.search_PSA = () => {
                const e = (item) => !item || item === '';
                if ((e($scope.criteria.vin_PSA) && e($scope.criteria.licensePlate_PSA))
                   /* || (e($scope.criteria.companyName) && e($scope.criteria.lastName))*/) {
                    ModalService.showError('gateway.views.modal.Error', 'psa.fnol.common.directives.policy-search-criteria.MinimumSearchCriteriaNeeded');
                } else {
                    $scope.search();
                }
            };
        }]
    };
}];